import { CommunityLanguage } from './CommunityLanguage.js'
import { PostTranslation } from './PostTranslation.js'

export const LocalizationSettings = () => {
  return (
    <div className="flex flex-col space-y-5 max-w-3xl">
      <CommunityLanguage />
      <PostTranslation />
    </div>
  )
}
